"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classMap_1 = __importDefault(require("../../shared/utilities/classMap"));
function Error(props) {
    return (react_1.default.createElement("div", { className: (0, classMap_1.default)("container-fluid", "mpng-ux-error", props.className) },
        react_1.default.createElement("div", { className: "row my-5" },
            react_1.default.createElement("div", { className: "col-lg-12" },
                react_1.default.createElement("h1", { className: "text-center mt-2 text-primary" }, props.primaryMsg),
                props.secondaryMsg && react_1.default.createElement("h2", { className: "text-center mt-2 text-secondary" }, props.secondaryMsg)),
            react_1.default.createElement("div", { className: "col-lg-12 text-center mt-4" },
                react_1.default.createElement("button", { type: "button", className: "btn btn-primary", onClick: function () {
                        if (typeof props.handleClick === "function") {
                            props.handleClick();
                        }
                    } }, props.buttonText)))));
}
exports.default = Error;
